<div class="cell">
  <ng-container
    *ngTemplateOutlet="
      template;
      context: {
        $implicit: data
      }
    "
  ></ng-container>
</div>
